export default __webpack_public_path__ + "static/media/FOOTER_LOGO.ee689fd9.svg";